import styled from 'styled-components'

const StyledCourseOnlyCheckout = styled.div`
  h1 {
    text-align: center;
  }

  .subscriber-disclaimer {
    padding: 16px;
    background-color: #dde2e5;
    font-weight: 600;
    margin-top: 30px;
    font-family: ${({ theme }) => theme.fonts.nunito};
    color: ${({ theme }) => theme.colors.gray[700]};
    border-radius: 10px;
    display: flex;
    align-items: center;

    a {
      font-family: 'Nunito', sans-serif;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.gray[700]};
      text-decoration: underline;
    }

    svg {
      height: 24px;
      margin-right: 1rem;
      flex-shrink: 0;
    }
  }

  .empty-state {
    margin-top: 30px;
  }

  .cart-area {
    margin-top: 30px;

    .cart-items {
      display: grid;
      grid-gap: 10px;
      padding: 0;
      list-style-type: none;
    }

    .payment-method {
      margin-top: 50px;
      font-family: ${({ theme }) => theme.fonts.lexend};
      background-color: ${({ theme }) => theme.colors.gray[100]};
      border-radius: 10px;
      padding: 30px;

      h2 {
        font-size: 20px;
        letter-spacing: 0.25px;
        color: ${({ theme }) => theme.colors.gray[500]};
        font-weight: 400;
      }

      .label-wrapper {
        margin: 10px 0 30px 0;

        .input-heading .input-label {
          color: ${({ theme }) => theme.colors.gray[600]};
        }
      }

      .checkbox {
        font-family: ${({ theme }) => theme.fonts.nunito};
      }
    }
  }

  .checkout-actions {
    display: grid;
    width: 100%;
    margin-top: 50px;
    justify-content: normal;
    align-items: flex-end;
    grid-gap: 2rem;

    .cart-total {
      width: 100%;
      font-weight: 600;
      font-size: 13px;
      color: ${({ theme }) => theme.colors.gray[600]};

      b {
        font-weight: 600;
        font-size: 1rem;
        color: ${({ theme }) => theme.colors.gray[800]};
        margin-left: 5px;
      }

      .discount-info {
        font-weight: 500;
        font-size: 1rem;
        color: ${({ theme }) => theme.colors.gray[500]};

        span {
          display: block;
          margin-bottom: 10px;
        }
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    .checkout-actions {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
  }
`

export default StyledCourseOnlyCheckout
